import React from "react";
import Icon from "./Icon";
export default function Zap(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1L2 13H11L10 21L20 9H11L12 1Z"
  }));
}
Zap.displayname = "Zap";
//# sourceMappingURL=Zap.js.map